import { takeLatest, call, put, select } from "redux-saga/effects";
import {
  emailOtpSendStart,
  emailOtpSendDone,
  emailOtpSendError,
  emailOtpVerifyStart,
  emailOtpVerifyError,
  emailOtpVerifyDone,
  onEmailOtpSend,
  onEmailOtpVerify,
} from "./redux";
import factory from "utils/getApiHandlerEffect";
import { PayloadAction } from "@reduxjs/toolkit";
import { SagaIterator } from "redux-saga";
import { selectActivationCode, selectUserCidpId } from "scenes/selectors";
import { mfaFlow } from "utils/enum";

export function* onSendEmailOtp(
  action: PayloadAction<mfaFlow>
): SagaIterator<void> {
  const cidpId = yield select(selectUserCidpId);
  const activationCode = yield select(selectActivationCode);
  const apiHandler = yield call(() => factory());
  yield put(emailOtpSendStart());
  try {
    yield call(() =>
      action.payload === mfaFlow.MFA
        ? apiHandler.putUpdateMFA("email", cidpId, {})
        : apiHandler.putMFAEnroll("email", activationCode)
    );
    yield put(emailOtpSendDone());
  } catch (e: any) {
    yield put(emailOtpSendError("Failed to send code. Please try again."));
  }
}

export function* onVerifyEmailOtp(
  action: PayloadAction<{ code: string; flow: mfaFlow }>
): SagaIterator<void> {
  const cidpId = yield select(selectUserCidpId);
  const activationCode = yield select(selectActivationCode);
  const apiHandler = yield call(() => factory());
  yield put(emailOtpVerifyStart());
  try {
    yield call(() =>
      action.payload.flow === mfaFlow.MFA
        ? apiHandler.updatePassCode("email", cidpId, action.payload.code)
        : apiHandler.submitAuthenticatorPassCode(
            "email",
            activationCode,
            action.payload.code
          )
    );
    yield put(emailOtpVerifyDone());
  } catch (e: any) {
    const msg =
      e?.statusCode === 400
        ? "Invalid or expired code. Please try again."
        : "Something went wrong. Please try again.";
    yield put(emailOtpVerifyError(msg));
  }
}

// watcher function
export default function* emailAuthenticatorSaga() {
  yield takeLatest(onEmailOtpSend.type, onSendEmailOtp);
  yield takeLatest(onEmailOtpVerify.type, onVerifyEmailOtp);
}
